import * as React from "react";
import type { SVGProps } from "react";
const SvgDownloadCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#download-circle_svg__a)">
      <path d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20m0-18a8 8 0 1 0 0 16 8 8 0 0 0 0-16" />
      <path d="M12 15.5a1 1 0 0 1-1-1v-6a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1" />
      <path d="M12 16.5a1 1 0 0 1-.71-.29l-3-3a1.004 1.004 0 0 1 1.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 1 1 1.42 1.42l-3 3a1 1 0 0 1-.71.29" />
    </g>
    <defs>
      <clipPath id="download-circle_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDownloadCircle;
